import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]

import { useActivityStore } from '@/stores/activity';
import { goToActivityPath } from '@/view/home/supportScript';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'floatButton',
  emits: ["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA", 'handleShowTreasurePopup'],
  setup(__props, { emit: __emit }) {

const activityStore = useActivityStore()
const homeIconList = computed(() => activityStore.homeFloatActivityList)
const isDisplay = ref(true)
const isScrolled = ref(false)
const router = useRouter()
const emits = __emit

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
    localStorage.setItem('redirectFromCalim', 'true')
}

const goToPath = (name: any) => {
    goToActivityPath(name, router,handleShowTreasurePopup, emits)
}

const leftIcons = computed(() => {
    const list = homeIconList.value || []
    return list.slice(0, Math.ceil(list.length / 2))
})
const rightIcons = computed(() => {
    const list = homeIconList.value || []
    return list.slice(Math.ceil(list.length / 2))
})

let scrollContainer: HTMLElement | Window = window
let scrollTimeout: number

const handleScroll = () => {
  const scrollTop =
    scrollContainer instanceof Window
      ? window.scrollY
      : scrollContainer.scrollTop

  isScrolled.value = scrollTop > 50

  clearTimeout(scrollTimeout)
  scrollTimeout = window.setTimeout(() => {
    isScrolled.value = false
  }, 500)
}

onMounted(() => {
  const app = document.querySelector('.scroll-container')
  scrollContainer = app || window
  scrollContainer.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  scrollContainer.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["float-container left-side", { scrolled: isScrolled.value }])
    }, [
      _createVNode(_TransitionGroup, {
        name: "pop",
        tag: "div",
        class: "icon-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isDisplay.value ? leftIcons.value : [], (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item?.name,
              class: "icon-wrapper",
              style: _normalizeStyle({ transitionDelay: `${index * 0.05}s` }),
              onClick: ($event: any) => (goToPath(item?.name))
            }, [
              _createElementVNode("img", {
                src: item?.icon,
                alt: ""
              }, null, 8, _hoisted_2)
            ], 12, _hoisted_1))
          }), 128))
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["float-container right-side", { scrolled: isScrolled.value }])
    }, [
      _createVNode(_TransitionGroup, {
        name: "pop",
        tag: "div",
        class: "icon-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isDisplay.value ? rightIcons.value : [], (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item?.name,
              class: "icon-wrapper",
              style: _normalizeStyle({ transitionDelay: `${index * 0.05}s` }),
              onClick: ($event: any) => (goToPath(item?.name))
            }, [
              _createElementVNode("img", {
                src: item?.icon,
                alt: ""
              }, null, 8, _hoisted_4)
            ], 12, _hoisted_3))
          }), 128))
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})